import { gql } from "@apollo/client";

export const INVALIDATE_CACHE = gql`
  mutation resetCache($input: ResetInputType!) {
    resetCache(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const CHECK_SERVICE = gql`
  mutation checkService($input: CheckServiceInputType!) {
    checkService(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ERP_VERSION = gql`
  mutation erpVersion {
    erpVersion {
      commandId
      correlationId
    }
  }
`;

export const REQUEST_DEIMOS_VERSION = gql`
  mutation requestDeimosVersion {
    requestDeimosVersion {
      commandId
      correlationId
    }
  }
`;

export const CHECK_CASCO_INSURANCE_FLOW = gql`
  mutation checkCASCOInsuranceFlow($input: CheckCASCOInsuranceFlowInput!) {
    checkCASCOInsuranceFlow(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const CHECK_CASCO_CROSS_CHECK_FLOW = gql`
  mutation checkCASCOCrossCheckFlow($input: CheckCASCOCrossCheckFlowInput!) {
    checkCASCOCrossCheckFlow(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const CHECK_RCA_CROSS_CHECK_FLOW = gql`
  mutation checkRCACrossCheckFlow($input: CheckRCACrossCheckFlowInput!) {
    checkRCACrossCheckFlow(input: $input) {
      commandId
      correlationId
    }
  }
`;
